<template>
  <div class="bottomContainer">
    <!-- footer -->
    <footer class="bg-li py-5">
      <div class="container py-xl-5 py-lg-3">
        <!-- subscribe -->
        <div class="subscribe mx-auto">
          <div class="icon-effect-w3">
            <span class="fa fa-envelope"></span>
          </div>
          <h2 class="tittle text-center font-weight-bold">
            {{ $t("bottomContent.contactEmail")
            }}<a href="mailto:contact@journal.ac.cn" class="emailC"
              >contact@journal.ac.cn</a
            >
          </h2>
          <p class="sub-tittle text-center mt-3">
            {{ $t("bottomContent.backContent") }}
          </p>
        </div>
      </div>
    </footer>
    <!-- //footer -->
    <div class="copy-bottom bg-li py-4 border-top">
      <div class="container-fluid">
        <div class="d-md-flex px-md-3 position-relative text-center">
          <!-- copyright -->
          <div class="copy_right mx-md-auto mb-md-0 mb-3">
            <p class="text-bl let">
              Copyright © 2016 - 2025 箭弩学术. All rights reserved.
              <a href="http://beian.miit.gov.cn">粤ICP备2025385369号-1</a>
            </p>
          </div>

          <a @click="scrollToTop" class="move-top text-center">
            <span class="fa fa-level-up" aria-hidden="true"></span>
          </a>
        </div>
      </div>
    </div>
    <!-- //copyright bottom -->
  </div>
</template>

<script>
export default {
  name: "BottomContainer",
  data() {
    return {};
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.move-top {
  cursor: pointer;
}

.emailC {
  color: #4e6ef2;
}

.emailC:hover {
  color: #4e6ef2 !important;
}
</style>
